

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../common/baseURL";
import logo from "../Assets/logg.png";
import Modal from "react-modal"; 
import {FaFolder} from 'react-icons/fa'
import { CiLogout } from "react-icons/ci";
import { IoMdAddCircle } from "react-icons/io";

const FileUpload = () => {
  const [folders, setFolders] = useState([]);
  const [message, setMessage] = useState("");
  const [folderName, setFolderName] = useState("");
  const [checkUploadOnce, setCheckUploadOnce] = useState(true);
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); 


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 568); // Set breakpoint for mobile view
    };
    handleResize(); // Check the initial window size
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchFolders = async () => {
      try {
        const response = await axios.get(`${baseURL}/folders`);
        setFolders(response.data);
      } catch (error) {
        alert("Error fetching folder list.");
      }
    };

    fetchFolders();
  }, []);

const handleLogoutButton=()=>{
  localStorage.removeItem("authTokenforEIF");
  localStorage.removeItem("expiryTime");
  navigate("/");
}

     
  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setFolderName("");
    const trimmedVlue = folderName.trimEnd()
    try {
      const response = await axios.post(`${baseURL}/create-folder`, {
        folderName:trimmedVlue
      });
      setCheckUploadOnce(false);
      setMessage(response.data);
      setIsButtonDisabled(true);
      const fileListResponse = await axios.get(`${baseURL}/folders`);
      setFolders(fileListResponse.data);
    } catch (error) {
      console.log(error);
      if (error.status === 400) {
        setMessage("Folder already exists. Please try another name");
      } else {
        setMessage(
          "Error creating folder. Please do not include special characters!"
        );
      }
    }
  };
  const fetchFilesAndSubdirectories = async (folderName) => {
    try {
        console.log('Fetching subdirectories for:', folderName);

        // Fetch subdirectories
        const subdirectoryResponse = await axios.get(`${baseURL}/folders/${folderName}`);
        console.log('Subdirectory API response:', subdirectoryResponse);

        if (subdirectoryResponse.data.length === 0) {
            console.log('No subdirectories found. Checking for files...');

            // Fetch files if no subdirectories exist
            const fileListResponse = await axios.get(`${baseURL}/files/${folderName}`);
            console.log('File list API response:', fileListResponse);

            // Check if files exist
            if (fileListResponse.data?.message === 'No files found in the folder.') {
               navigate('/sub', { state: { folderName } })
                // alert('No subdirectories or files found in this folder.');
            } else if (Array.isArray(fileListResponse.data) && fileListResponse.data.length > 0) {
                console.log('Files found in this folder:', fileListResponse.data);
                navigate("/files", { state: { folderName } });
            } else {
                console.log('Unexpected file list response:', fileListResponse.data);
                
                // alert('Unable to determine folder contents.');
            }
        } else {
            console.log('Subdirectories found:', subdirectoryResponse.data);
            navigate('/sub', { state: { folderName } })
            // setSubDirectories(subdirectoryResponse.data);
        }
    } catch (error) {
        console.error('Error details:', error.response || error.message || error);
        // alert('Error fetching file list or subdirectories.');
    }
};

  const handleInputChange = (event) => {
    const value = event.target.value;
    const regex = /^[a-zA-Z0-9\s]*$/; // Allows only letters, numbers, and spaces

    if (!regex.test(value)) {
      setMessage("Folder name cannot include special characters!");
      return;
    }

    setFolderName(value);
    setCheckUploadOnce(true);
    setMessage("");
    if (isButtonDisabled) {
      setIsButtonDisabled(false);
    }
  };

  const handleDelete = async (folderName) => {
    if (
      window.confirm(
        `Are you sure you want to delete the folder "${folderName}"?`
      )
    ) {
      try {
        await axios.delete(`${baseURL}/folders/${folderName}`);
        setFolders(folders.filter((folder) => folder !== folderName));
      } catch (error) {
        alert("Error deleting folder.");
      }
    }
  };

  const handleFolderClick = (folderName) => {
    //navigate("/sub", { state: { folderName } });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {isMobile ? (
        <div style={{...styles.containerM, flexDirection:'column'}}>
          <div
            style={{
              display: "flex",
              backgroundColor: "white",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100vw",
              top: 60,
              background:
              "white"
                //"linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
            }}
          >
            <img
              style={{
                width: "auto",
                height: "35px",
                alignSelf: "left",
                alignSelf: "center",
                marginLeft: 20,
              }}
              src={logo}
            ></img>
            {/* <button onClick={openModal} 
            //style={styles.addFolderButton}
            > */}
             <span onClick={openModal}><IoMdAddCircle fill="#191c51" style={{margin:10}}  size={50}/></span>
            {/* </button> */}
          </div>
          <div
            style={{
              display:'flex',
              // ...styles.containerM,
              alignItems: "center",
            //   justifyContent: "center",
              textAlign: "left",
              flexDirection: "column",
            }}
          >
            <h3 style={{ textAlign: "left", fontFamily: "Montserrat" }}>
              All Folders
            </h3>
            <div style={styles.folderListM}>
              {folders.map((folder) => (
                <div key={folder} style={styles.folderItemM}>
                  <span
                    onClick={() => fetchFilesAndSubdirectories(folder)}
                    style={{...styles.folderNameM,display:'flex',gap:5}}
                  >
                 <span>  <FaFolder style={{verticalAlign:''}}></FaFolder></span>  {folder === "DiscussionLab" ? "DiscussionTheatre" : folder}
                  </span>
                </div>
              ))}
            </div>

            <button    style={{
                                           ...styles.button1,
                                           fontFamily: "Montserrat",
                                           color:'white',
                                          // marginLeft:'auto',
                                          marginBottom:20,
                                          borderRadius:50,
                                          // marginRight:20,
                                          width:'90%'
                                           
                                         }} 
                                         onClick={handleLogoutButton}
                                         >Logout <span><CiLogout style={{verticalAlign:'middle' }} size={20}></CiLogout></span></button>
          </div>
         
        </div>
      ) : (
        <div style={styles.container}>
          <div style={styles.sidebar}>
            <img
              style={{ width: "auto", alignSelf: "left", display: "flex",height:'50px' }}
              src={logo}
            ></img>
            <h3 style={{ textAlign: "left", fontFamily: "Montserrat",fontSize:24 }}>
              All Folders
            </h3>
            {folders.length > 0 ? (
              <>
                {" "}
                <div style={styles.folderList}>
                  {folders.map((folder) => (
                    <div key={folder} style={styles.folderItem}>
                      <span
                        onClick={() => fetchFilesAndSubdirectories(folder)}
                        style={{...styles.folderName,fontSize:20,gap:5}}
                      >
                       <span><FaFolder style={{verticalAlign:'',fill:'#191c51',}}></FaFolder></span> {folder === "DiscussionLab" ? "DiscussionTheatre" : folder}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>No Folders...</>
            )}
          </div>

          <div style={styles.content}>
         
            <form
              id="uploadForm"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              style={styles.form}
            >
              
              <input
                type="text"
                value={folderName}
                required
                placeholder="Enter Folder Name .."
                onChange={handleInputChange}
                style={styles.fileInput}
              />
              <button
                type="submit"
                disabled={isButtonDisabled}
                style={{
                  ...styles.button,
                  fontFamily: "Montserrat",
                  background: isButtonDisabled
                    ? "black"
                    : "linear-gradient(to right, #191c51, #2092d0)",
                }}
              >
                Create Folder
              </button>
              <div
                id="message"
                style={{
                  ...styles.message,
                  color: isButtonDisabled ? "green" : "black",
                }}
              >
                {message}
              </div>
            </form>
            <button    style={{
                                           ...styles.button1,
                                           fontFamily: "Montserrat",
                                           color:'white',
                                          marginLeft:'auto',
                                          marginBottom:20,
                                          width:'100%'
                                           
                                         }} 
                                         onClick={handleLogoutButton}
                                         >Logout <span><CiLogout style={{verticalAlign:'middle' }} size={20}></CiLogout></span></button>
          </div>
        </div>
      )}
      
  
      {/* Modal for mobile view */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={modalStyles}
      >
        {/* <h2 style={{color:'white'}}>Create Folder</h2> */}
        <div>
          <br></br>
        </div>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={folderName}
            required
            placeholder="Enter Folder Name"
            onChange={handleInputChange}
            style={styles.fileInput}
          />
             <div
                id="message"
                style={{
                  ...styles.message,
                  marginBottom:20,
                  color: isButtonDisabled ? "green" : "black",
                }}
              >
                {message}
              </div>
          <button
            type="submit"
            disabled={isButtonDisabled}
            style={{
              ...styles.button,
              fontFamily: "Montserrat",
              background: isButtonDisabled
                ? "black"
                : "linear-gradient(to right, #191c51, #2092d0)",
            }}
          >
            Create Folder
          </button>
        </form>
        <button onClick={closeModal} style={styles.button1}>
          Close
        </button>
      </Modal>
    </div>
  );
};

// Styles for modal
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Solid white background for the screen
    zIndex: 1000, // Ensure it stays above other content
  },
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "400px",
    padding: "20px",
    background: 'linear-gradient(to right, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
  },
};

// Add Folder button style for mobile
const styles = {
  containerM: {
    display: "flex",
    // height: "100vh",
    fontFamily: "Arial, sans-serif",
    background: 'linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))',
  },
  button1: {
    marginTop: "20px",
    fontWeight: "bold",
    padding: "10px",
    color: "white",
    background: "linear-gradient(to right, #AA0000, #CD5C5C)",
    border: "none",
    borderRadius: "5px",
    marginLeft: "4px",
    fontFamily: "Montserrat",
  },
  sidebar: {
    // width: "250px",
    padding: "20px",
    backgroundColor: "#f4f4f4",
    // width:'45%'
  },
  content: {
    flex: 1,
    padding: "20px",
  },
  folderListM: {
    marginTop: "20px",
    background: "#fff",
    background:'transparent',
    alignSelf:'center',
    justifyItems:'center',
    fontFamily: "Montserrat",
    // overflowY: 'auto',
  },
  folderItemM: {
    padding: "10px",
    margin: "10px 0",
    background: "white",
    //background: 'linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))',
    cursor: "pointer",
    width:'90%',
    border:'2px solid  rgba(28, 34, 86, 0.6)',
    borderRadius:20
  },
  folderNameM: {
    fontSize: "16px",
  },
  addFolderButton: {
    margin: 10,
    backgroundColor: "white",
    color: "white",
    fontSize: "24px",
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: 'linear-gradient(to right, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',
  },
  form: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fileInput: {
    padding: "10px",
    fontSize: "16px",
    marginBottom: "20px",
    width: "100%",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    borderRadius: "5px",
  },
  message: {
    fontSize: "14px",
    marginTop: "10px",
  },
  closeModalButton: {
    backgroundColor: "#ff6f61",
    color: "white",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginTop: "20px",
  },

  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Arial, sans-serif",
    background:
      "linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
  },
  sidebar: {
     width: "55%",
    padding: "20px",
    background: "#fff",
    borderRight: "1px solid #ccc",
    overflowY: "auto",
    margin: 20,
    // backgroundColor:'red'
    // marginRight:2
  },
  folderList: {
    marginTop: "10px",
    maxHeight: "75vh",
    textAlign: "left",
    fontFamily: "Montserrat",
  },
  folderItem: {
    marginBottom: "10px",
  },
  folderName: {
    cursor: "pointer",
    // textDecoration: 'underline',
    color: "black",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    background: "#fff",
    // borderRadius: '8px',
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    width: "96%",
    height: "100%",
    justifyContent: "center",
  },
  fileInput: {
    marginBottom: "10px",
    padding: "5px",
    width: "100%",
    maxWidth: "300px",
    // border:'solid 1px'
  },
  button: {
    padding: "10px 20px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
  },
  message: {
    marginTop: "15px",
  },
  folderItem: {
    marginBottom: "10px",
  },
  folderName: {
    cursor: "pointer",
    // textDecoration: 'underline',
    color: "black",
  },
};

export default FileUpload;
